import React from "react";
import { useState } from "react";
import { usePageSearchState } from "../../../../db";
import { mobile, parseStyle, decodeStyle, tablet } from "../../../../juntion";
import QPopupForm from "../../../../../forms/QPopupForm";
import { useAction } from "../../../../hooks";
import classNames from "classnames";
import { css } from "@emotion/css";
// import { getRecordId } from "../../../../../dynamicdata/parser";
import { getRecordId } from "../../../../junctionAbs";

function PopupForm({ id, db, device, gs, dydb, ctx }) {
    const data = db[id];
    const { performAction } = useAction();

    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const record_id = getRecordId(dydb, input.editRecord);

    let field_overwrites = null;
    try {
        field_overwrites = input.fields_overwrite
            ? JSON.parse(input.fields_overwrite)
            : null;
    } catch (error) {}

    const btnData = input.buttonType;
    const icon = btnData?.type !== "text" && (
        <i
            className={btnData.params.icon.value}
            style={{
                zoom: 0.9,
                marginRight:
                    btnData?.params?.text && !btnData?.params?.icon_right
                        ? "1rem"
                        : "auto",
                marginLeft:
                    btnData?.params?.text && btnData?.params?.icon_right
                        ? "1rem"
                        : "auto",
            }}
        ></i>
    );

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: input.buttonAlign,
            }}
        >
            <QPopupForm
                id={input.form}
                record_id={record_id}
                org={ctx.organization}
                title={record_id ? "Edit Item" : "Create Item"}
                field_overwrites={field_overwrites}
                trigger={
                    <button
                        className={classNames(
                            input.hoverAnimation,
                            css({
                                ...decodeStyle(ps.fixStyle, gs),
                                ...decodeStyle(ps.styleGroup.button, gs),
                                // ...(tablet(device) &&
                                // decodeStyle(tabletStyle, gs)),
                                // ...(mobile(device) &&
                                // decodeStyle(mobileStyle, gs)),
                                alignSelf: input.buttonAlign,
                                textTransform: btnData?.params?.uppercase
                                    ? "uppercase"
                                    : "none",
                                gap: "1.5rem",
                                fontWeight: input.bold ? "bold" : "normal",
                                fontSize: input.size || "12px",
                                cursor: "pointer",
                                margin: "10px",
                                "&:hover": {
                                    ...decodeStyle(ps.style__hover || {}, gs),
                                },
                                "&:active": {
                                    ...decodeStyle(
                                        ps.style__selected || {},
                                        gs
                                    ),
                                },
                            })
                        )}
                    >
                        {btnData?.params?.icon &&
                            !btnData.params.icon_right &&
                            icon}
                        {btnData?.params?.text && btnData.params.text}
                        {btnData?.params?.icon &&
                            btnData.params.icon_right &&
                            icon}
                    </button>
                }
                wrapper_style={{
                    background: "white",
                    fontSize: input.fontSize,
                    fontWeight: input.bold ? "bold" : "normal",
                    textTransform: input.uppercase ? "uppercase" : "none",
                }}
                configs={{
                    submitButtonText: input.submitButtonText,
                    submittingButtonText: input.submittingButtonText,
                    successMessage: input.successMessage,
                }}
            />
        </div>
    );
}

export default PopupForm;
